import styled from 'styled-components'
import React from 'react'
import { device, GRID_BREAKPOINTS } from '@util/breakpoints'

export type GridProps = {
  columns?: number
  rows?: number
  height?: string
  minMax?: { min: string; max: string }
  gridGap?: string
  mobilePadding?: string
  mobileCarousel?: boolean
  margin?: string
}

const gridTemplateColumns = ({ minMax = { min: '160px', max: 'auto' } }) =>
  `repeat(auto-fit, minmax(${minMax.min}, ${minMax.max}))`
const gridTemplateRows = ({ rows = 1 }) => `repeat(${rows}, auto)`

export const Grid = styled.div<GridProps>`
  @media ${device.desktop} {
    display: grid;
    padding: 0;
  }

  @media ${device.desktopM} {
    display: grid;
    padding: 0;
  }

  @media ${device.tablet} {
    display: grid;
    padding: 0;
  }
  margin: ${({ margin }) => margin};

  width: 100%;
  padding: ${({ mobilePadding }) =>
    mobilePadding ? '0 ' + mobilePadding : '0'};
  height: ${({ height = 'auto' }) => height};
  // at lower than  tablet resolution we want to auto so its one per row
  grid-template-columns: ${gridTemplateColumns};
  grid-template-rows: ${gridTemplateRows};
  grid-gap: ${({ gridGap = 'auto' }) => gridGap};
  // at tablet resolution and above we want to use with column property
  @media ${device.tablet} {
    grid-template-columns: ${(props) => `repeat(${props.columns}, 1fr)`};
  }
`

type WrapperProps = {
  maxWidth: GRID_BREAKPOINTS
}

export const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  max-width: ${({ maxWidth = 'auto' }) => maxWidth};
  margin: auto;
`

export type CellProps = {
  width?: number
  height?: number
  middle?: boolean
  center?: boolean
}
export const Cell = styled.div<CellProps>`
  height: 100%;
  grid-column-end: ${({ width = 1 }) => `span ${width}`};
  grid-row-end: ${({ height = 1 }) => `span ${height}`};
  ${({ center }) => center && `text-align: center`};
  ${({ middle }) =>
    middle &&
    `
    display: inline-flex;
    flex-flow: column wrap;
    justify-content: center;
    justify-self: stretch;
  `};
`
